import React, { useEffect, useState ,useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";

const AddDoctor = ({ item, onAddDepart }) => {
  // ✅ Add errors state
  const [errors, setErrors] = useState({});
  
  const [formData, setFormData] = useState({
    cats: [],
    user_id: "",
    doc_reg_number: "",
    fname: "",
    lname: "",
    gender: "male",
    mobile: "",
    email: "",
    website: "",
    pincode: "",
    country: "",
    city: "",
    state: "",
    company: "",
    gst: "",
    address: "",
    address_line1: "",
    address_line2: "",
    doc_joining_date: "",
    type: "doctor",
    doc_fees: "",
    doc_degree: "",
    doc_designation: "",
    doc_specality: "",
    lab_commission_pathology_type: "",
    lab_commission_pathology: "",
    lab_commission_radiology_type: "",
    lab_commission_radiology: "",
    lab_commission_type: "",
    lab_commission: "",
    hospital_commission_type: "",
    hospital_commission: "",
    pharmacy_commission_type: "",
    pharmacy_commission: "",
    doc_user: "",
    notes: "",
    alertMsg: "",
    alertMsgTyp: "",
    isAlert: false,
  });

  const [ldata, setLdata] = useState(null);

// Test-wise commission state
const [testCommissions, setTestCommissions] = useState([]); // [{test_id, test_name, commission_type, commission}]
const [testSearchKey, setTestSearchKey] = useState("");
const [testSearchResults, setTestSearchResults] = useState([]);
const [showTestDropdown, setShowTestDropdown] = useState(false);
const [testSearchLoading, setTestSearchLoading] = useState(false);
const testSearchDebounceRef = useRef(null);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
      user_id: "",
      doc_reg_number: "",
      fname: "",
      lname: "",
      gender: "male",
      mobile: "",
      email: "",
      website: "",
      pincode: "",
      country: "",
      city: "",
      state: "",
      company: "",
      gst: "",
      address: "",
      address_line1: "",
      address_line2: "",
      doc_joining_date: "",
      type: "doctor",
      doc_fees: "",
      doc_degree: "",
      doc_designation: "",
      doc_specality: "",
      lab_commission_pathology_type: "",
      lab_commission_pathology: "",
      lab_commission_radiology_type: "",
      lab_commission_radiology: "",
      lab_commission_type: "",
      lab_commission: "",
      hospital_commission_type: "",
      hospital_commission: "",
      pharmacy_commission_type: "",
      pharmacy_commission: "",
      doc_user: "",
      notes: "",
      alertMsg: "",
      alertMsgTyp: "",
      isAlert: false,
    }));
    setErrors({});
    setTestCommissions([]);  // ✅ Clear errors
  };

  const closeBootstrapModal = () => {
    try {
      const modalEl = document.getElementById("showModal");
      if (!modalEl) {
        console.warn("closeBootstrapModal: '#showModal' not found");
        return;
      }

      if (typeof window !== "undefined" && window.bootstrap && window.bootstrap.Modal) {
        try {
          const instance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          if (instance) instance.hide();
        } catch (err) {}
      }

      if (typeof window !== "undefined" && window.jQuery) {
        try {
          window.jQuery(modalEl).modal("hide");
        } catch (err) {}
      }

      setTimeout(() => {
        try {
          modalEl.classList.remove("show");
          modalEl.style.display = "none";
          modalEl.setAttribute("aria-hidden", "true");
          modalEl.removeAttribute("aria-modal");
          const backdrops = document.querySelectorAll(".modal-backdrop");
          backdrops.forEach((b) => b.parentNode && b.parentNode.removeChild(b));
          document.body.classList.remove("modal-open");
        } catch (e) {
          console.warn("modal manual cleanup failed", e);
        }
      }, 50);
    } catch (ex) {
      console.error("closeBootstrapModal error", ex);
    }
  };

  // ✅ Add validation function
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.fname || formData.fname.trim() === '') {
      newErrors.fname = 'Doctor name is required';
    }
    
    if (!formData.email || formData.email.trim() === '') {
      newErrors.email = 'Email is required';
    }
    
    if (!formData.doc_specality || formData.doc_specality.trim() === '') {
      newErrors.doc_specality = 'Speciality is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
// Search tests for the dropdown
const fetchTestsForCommission = async (key = "") => {
  try {
    setTestSearchLoading(true);
    const fd = new FormData();
    fd.append("type", "test");
    fd.append("search_key", key);
    fd.append("page_no", "none");
    fd.append("test_user", 1);
    const res = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (res?.data?.status) setTestSearchResults(res.data.records || []);
    else setTestSearchResults([]);
  } catch (e) {
    console.error("fetchTestsForCommission", e);
    setTestSearchResults([]);
  } finally {
    setTestSearchLoading(false);
  }
};

// Debounce test search
useEffect(() => {
  if (testSearchDebounceRef.current) clearTimeout(testSearchDebounceRef.current);
  testSearchDebounceRef.current = setTimeout(() => {
    fetchTestsForCommission(testSearchKey.trim());
  }, 300);
  return () => clearTimeout(testSearchDebounceRef.current);
}, [testSearchKey]);

// Add a test row
const handleAddTestCommission = (test) => {
  const testId = String(test.test_id ?? test.id ?? "");
  if (!testId) return;
  // prevent duplicate
  if (testCommissions.some(t => String(t.test_id) === testId)) {
    Swal.fire({ icon: "info", title: "Already added", text: "This test is already in the list." });
    return;
  }
  setTestCommissions(prev => ([
    ...prev,
    {
      test_id: testId,
      test_name: test.test_name ?? test.name ?? "",
      commission_type: "fix",
      commission: 0,
    }
  ]));
  setTestSearchKey("");
  setShowTestDropdown(false);
};

// Update a row
const handleTestCommissionChange = (idx, field, value) => {
  setTestCommissions(prev => {
    const next = [...prev];
    next[idx] = { ...next[idx], [field]: value };
    return next;
  });
};

// Delete a row
const handleDeleteTestCommission = (idx) => {
  setTestCommissions(prev => prev.filter((_, i) => i !== idx));
};

// Fetch existing rules when editing
const loadExistingTestCommissions = async (userId) => {
  if (!userId) { setTestCommissions([]); return; }
  try {
    const fd = new FormData();
    fd.append("user_id", String(userId));
    const res = await axios.post(AppConst.BASE_URL + AppConst.getDocTestCommissionUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (res?.data?.status && Array.isArray(res.data.records)) {
      setTestCommissions(res.data.records.map(r => ({
        test_id: String(r.test_id),
        test_name: r.test_name || "",
        commission_type: r.commission_type || "fix",
        commission: parseFloat(r.commission || 0),
      })));
    } else {
      setTestCommissions([]);
    }
  } catch (e) {
    console.error("loadExistingTestCommissions", e);
    setTestCommissions([]);
  }
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ✅ Validate before submit
    if (!validateForm()) {
      await Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill all required fields",
      });
      return;
    }

    const isEditing = !!(formData.user_id && String(formData.user_id).trim().length > 0);

    const fd = new FormData();
    fd.append("user_id", formData.user_id ?? "");
    fd.append("doc_reg_number", formData.doc_reg_number ?? "");
    fd.append("fname", formData.fname ?? "");
    fd.append("lname", formData.lname ?? "");
    fd.append("gender", formData.gender ?? "male");
    fd.append("mobile", formData.mobile ?? "");
    fd.append("email", formData.email ?? "");
    fd.append("website", formData.website ?? "");
    fd.append("pincode", formData.pincode ?? "");
    fd.append("country", formData.country ?? "");
    fd.append("city", formData.city ?? "");
    fd.append("state", formData.state ?? "");
    fd.append("company", formData.company ?? "");
    fd.append("gst", formData.gst ?? "");
    fd.append("address", formData.address ?? "");
    fd.append("address_line1", formData.address_line1 ?? "");
    fd.append("address_line2", formData.address_line2 ?? "");
    fd.append("doc_joining_date", formData.doc_joining_date ?? "");
    fd.append("type", formData.type ?? "doctor");
    fd.append("doc_fees", formData.doc_fees ?? "");
    fd.append("doc_degree", formData.doc_degree ?? "");
    fd.append("doc_designation", formData.doc_designation ?? "");
    fd.append("doc_specality", formData.doc_specality ?? "");

    fd.append("lab_commission_pathology_type", formData.lab_commission_pathology_type ?? "");
    fd.append("lab_commission_pathology", formData.lab_commission_pathology ?? "");
    fd.append("lab_commission_radiology_type", formData.lab_commission_radiology_type ?? "");
    fd.append("lab_commission_radiology", formData.lab_commission_radiology ?? "");

    fd.append("lab_commission_type", formData.lab_commission_type ?? "");
    fd.append("lab_commission", formData.lab_commission ?? "");
    fd.append("hospital_commission_type", formData.hospital_commission_type ?? "");
    fd.append("hospital_commission", formData.hospital_commission ?? "");
    fd.append("pharmacy_commission_type", formData.pharmacy_commission_type ?? "");
    fd.append("pharmacy_commission", formData.pharmacy_commission ?? "");
    fd.append("doc_user", ldata?.user_id ?? "1");
    fd.append("notes", formData.notes ?? "");
// Send test-wise commissions as JSON
    fd.append("test_commissions", JSON.stringify(testCommissions));
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addUserUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response?.data?.status) {
        const swalTitle = isEditing ? "Doctor updated" : "Doctor added";
        const serverMsg = response.data.success ?? "";

        await Swal.fire({
          icon: "success",
          title: swalTitle,
          text: serverMsg,
          showConfirmButton: false,
          timer: 1400,
        });

        closeBootstrapModal();
        resetForm();

       if (typeof onAddDepart === "function") {
    setTimeout(() => {
      onAddDepart({
        user_id: response.data.user_id ?? response.data.id ?? null,
        fname: formData.fname,
        lname: formData.lname,
      });
    }, 180);
  }
}
      else {
        const errMsg = response?.data?.success ?? "Operation failed";
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: errMsg,
        });
        setFormData((prev) => ({
          ...prev,
          isAlert: true,
          alertMsg: errMsg,
          alertMsgTyp: response?.data?.type ?? "danger",
        }));
      }
    } catch (err) {
      console.error("AddDoctor submit error:", err);
      await Swal.fire({
        icon: "error",
        title: "Server error",
        text: "Please try again.",
      });
      setFormData((prev) => ({
        ...prev,
        isAlert: true,
        alertMsg: "Server error",
        alertMsgTyp: "danger",
      }));
    }
  };

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        setLdata(parsed);
      } catch (e) {}
    }

    const fd0 = new FormData();
    fd0.append("cat_type", "speciality");
    fd0.append("page_no", "none");
    fd0.append("par_by", 1 + "");
    try {
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (resp?.data?.status) {
        setFormData((prev) => ({ ...prev, cats: resp.data.records ?? [] }));
      }
    } catch (err) {
      console.error("initData getCatList error", err);
    }
  };

  useEffect(() => {
    initData();

    if (item) {
      try {
        setFormData((prev) => ({
          ...prev,
          doc_reg_number: item?.doc?.doc_reg_number ?? prev.doc_reg_number,
          fname: item?.fname ?? prev.fname,
          lname: item?.lname ?? prev.lname,
          gender: item?.gender ?? prev.gender,
          mobile: item?.mobile ?? prev.mobile,
          email: item?.email ?? prev.email,
          website: item?.website ?? prev.website,
          pincode: item?.pincode ?? prev.pincode,
          country: item?.country ?? prev.country,
          city: item?.city ?? prev.city,
          state: item?.state ?? prev.state,
          company: item?.company ?? prev.company,
          gst: item?.gst ?? prev.gst,
          address: item?.address ?? prev.address,
          doc_joining_date: item?.doc?.doc_joining_date ?? prev.doc_joining_date,
          type: item?.type ?? prev.type,
          doc_fees: item?.doc?.doc_fees ?? prev.doc_fees,
          doc_degree: item?.doc?.doc_degree ?? prev.doc_degree,
          doc_designation: item?.doc?.doc_designation ?? prev.doc_designation,
          doc_specality: item?.doc?.doc_specality ?? prev.doc_specality,

          lab_commission_pathology_type: item?.doc?.lab_commission_pathology_type ?? item?.doc?.lab_commission_type ?? prev.lab_commission_pathology_type,
          lab_commission_pathology: item?.doc?.lab_commission_pathology ?? item?.doc?.lab_commission ?? prev.lab_commission_pathology,
          lab_commission_radiology_type: item?.doc?.lab_commission_radiology_type ?? prev.lab_commission_radiology_type,
          lab_commission_radiology: item?.doc?.lab_commission_radiology ?? prev.lab_commission_radiology,

          lab_commission_type: item?.doc?.lab_commission_type ?? prev.lab_commission_type,
          lab_commission: item?.doc?.lab_commission ?? prev.lab_commission,
          hospital_commission_type: item?.doc?.hospital_commission_type ?? prev.hospital_commission_type,
          hospital_commission: item?.doc?.hospital_commission ?? prev.hospital_commission,
          pharmacy_commission_type: item?.doc?.pharmacy_commission_type ?? prev.pharmacy_commission_type,
          pharmacy_commission: item?.doc?.pharmacy_commission ?? prev.pharmacy_commission,
          doc_user: item?.doc?.doc_user ?? prev.doc_user,
          address_line1: item?.address_line1 ?? prev.address_line1,
          address_line2: item?.address_line2 ?? prev.address_line2,
          notes: item?.notes ?? prev.notes,
          user_id: item?.user_id != null ? String(item.user_id) : "",
        }));
        setErrors({}); // ✅ Clear errors on edit
      } catch (err) {
        console.error("Error populating edit item:", err);
      }
// load test-wise commissions for this doctor
if (item?.user_id) {
  loadExistingTestCommissions(item.user_id);
} else {
  setTestCommissions([]);
}
      const modalEl = document.getElementById("showModal");
      try {
        document.querySelectorAll(".modal-backdrop").forEach(b => b.parentNode && b.parentNode.removeChild(b));
        document.body.classList.remove("modal-open");
      } catch (e) {}
      if (modalEl && typeof window !== "undefined" && window.bootstrap && window.bootstrap.Modal) {
        try {
          const inst = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          inst.show();
        } catch (e) {}
      }
    } else {
      resetForm();
    }
    
  }, [item]);

  const isEditing = !!(formData.user_id && String(formData.user_id).trim().length > 0);

  return (
    <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
            <h5 className="modal-title" id="exampleModalLabel">
              {isEditing ? "Edit Doctor" : "Add Doctor"}
            </h5>

            <button type="button" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" data-bs-dismiss="modal" id="close-modal">
              Close
            </button>
          </div>

          <form className="tablelist-form" onSubmit={handleSubmit}>
            <div className="modal-body">
              <input id="id-field" type="hidden" value={formData.user_id} />

              <div className="row gy-4 mb-3">
                <div className="col-md-3">
                  <label className="form-label">
                    Doctor Name <span className="text-danger">*</span>
                  </label>
                  <input 
                    name="fname" 
                    onChange={handleChange} 
                    value={formData.fname} 
                    className={`form-control ${errors.fname ? 'is-invalid' : ''}`}
                    placeholder="Enter name" 
                    type="text" 
                    required 
                  />
                  {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                </div>

                <div className="col-md-3">
                  <label className="form-label">Reg. Number</label>
                  <input name="doc_reg_number" className="form-control" onChange={handleChange} value={formData.doc_reg_number} placeholder="Reg. Number" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Mobile</label>
                  <input name="mobile" onChange={handleChange} value={formData.mobile} className="form-control" placeholder="Mobile" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">
                    Gender <span className="text-danger">*</span>
                  </label>
                  <select className="form-control" name="gender" onChange={handleChange} value={formData.gender} required>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input 
                    name="email" 
                    onChange={handleChange} 
                    value={formData.email} 
                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                    placeholder="Email for Login" 
                    type="email"
                    required
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="col-md-3">
                  <label className="form-label">Address Line 1</label>
                  <input className="form-control" name="address_line1" onChange={handleChange} value={formData.address_line1} placeholder="Address Line 1" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Address Line 2</label>
                  <input className="form-control" name="address_line2" onChange={handleChange} value={formData.address_line2} placeholder="Address Line 2" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">City</label>
                  <input name="city" onChange={handleChange} value={formData.city} className="form-control" placeholder="City" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">State</label>
                  <input name="state" onChange={handleChange} value={formData.state} className="form-control" placeholder="State" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Joining Date</label>
                  <input className="form-control" name="doc_joining_date" onChange={handleChange} value={formData.doc_joining_date} placeholder="Joining Date" type="date" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Designation</label>
                  <input className="form-control" name="doc_designation" onChange={handleChange} value={formData.doc_designation} placeholder="Designation" type="text" />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Degree</label>
                  <input className="form-control" name="doc_degree" onChange={handleChange} value={formData.doc_degree} placeholder="Degree" type="text" />
                </div>


{/* ✅ OPD FEES FIELD */}
<div className="col-md-3">
  <label className="form-label">OPD Fees</label>
  <input
    className="form-control"
    name="doc_fees"
    onChange={handleChange}
    value={formData.doc_fees ?? ""}
    placeholder="Enter OPD Fees"
    type="number"
    min="0"
    step="0.01"
  />
</div>

                {/* ✅ UPDATED SPECIALITY FIELD */}
                <div className="col-md-3">
                  <label className="form-label">
                    Speciality <span className="text-danger">*</span>
                  </label>
                  
                  <Select
                    name="doc_specality"
                    value={
                      formData.cats
                        .filter(cat => cat.cat_id === formData.doc_specality)
                        .map(cat => ({ value: cat.cat_id, label: cat.cat_name }))[0] || null
                    }
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({
                        ...prev,
                        doc_specality: selectedOption ? selectedOption.value : "",
                      }));
                      // Clear error when user selects
                      if (selectedOption) {
                        setErrors((prev) => ({ ...prev, doc_specality: '' }));
                      }
                    }}
                    options={formData.cats.map(cat => ({
                      value: cat.cat_id,
                      label: cat.cat_name
                    }))}
                    placeholder="Select Speciality"
                    isClearable
                    isSearchable
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: errors.doc_specality ? '#dc3545' : state.isFocused ? '#86b7fe' : '#dee2e6',
                        boxShadow: errors.doc_specality 
                          ? '0 0 0 0.25rem rgba(220, 53, 69, 0.25)' 
                          : state.isFocused 
                            ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' 
                            : 'none',
                        '&:hover': {
                          borderColor: errors.doc_specality ? '#dc3545' : '#86b7fe',
                        }
                      })
                    }}
                  />
                  
                  {/* Hidden input for HTML5 validation */}
                  <input
                    type="text"
                    value={formData.doc_specality || ''}
                    onChange={() => {}}
                    required
                    style={{ 
                      opacity: 0, 
                      height: 0, 
                      width: 0, 
                      position: 'absolute',
                      pointerEvents: 'none'
                    }}
                    tabIndex={-1}
                    aria-hidden="true"
                  />
                  
                  {/* Error message */}
                  {errors.doc_specality && (
                    <div className="invalid-feedback d-block">
                      {errors.doc_specality}
                    </div>
                  )}
                </div>

               
                

               {/* ============ LABORATORY ============ */}
<div className="col-md-12">
  <h4 style={{ color: '#003366', borderBottom: '2px solid #003366', paddingBottom: 6 }}>
    Laboratory Commission
  </h4>
</div>

{/* --- TEST-WISE COMMISSION --- */}
<div className="col-md-12">
  <h6 style={{ color: '#405189', marginTop: 8 }}>Test-wise Commission (overrides Pathology/Radiology)</h6>
</div>

<div className="col-md-6" style={{ position: 'relative' }}>
  <label className="form-label">Search test to add</label>
  <input
    type="text"
    className="form-control"
    placeholder="Type test name..."
    value={testSearchKey}
    onChange={(e) => { setTestSearchKey(e.target.value); setShowTestDropdown(true); }}
    onFocus={() => { setShowTestDropdown(true); if (!testSearchKey) fetchTestsForCommission(""); }}
    onBlur={() => setTimeout(() => setShowTestDropdown(false), 200)}
  />
  {showTestDropdown && (
    <div style={{
      position: 'absolute', top: '100%', left: 12, right: 12, zIndex: 1050,
      maxHeight: 220, overflowY: 'auto', background: '#fff',
      border: '1px solid #dee2e6', borderRadius: 4,
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    }}>
      {testSearchLoading ? (
        <div className="p-2 text-center"><span className="spinner-border spinner-border-sm me-2"/>Searching...</div>
      ) : testSearchResults.length === 0 ? (
        <div className="p-2 text-muted text-center">No tests found</div>
      ) : testSearchResults.map((t, i) => (
        <div key={i}
          onMouseDown={(e) => { e.preventDefault(); handleAddTestCommission(t); }}
          style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
          onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
          onMouseLeave={e => e.currentTarget.style.background = '#fff'}
        >
          <div className="d-flex justify-content-between">
            <strong>{t.test_name}</strong>
            <span className="text-success">₹{t.test_price}</span>
          </div>
        </div>
      ))}
    </div>
  )}
</div>

<div className="col-md-12">
  {testCommissions.length === 0 ? (
    <div className="alert alert-light border" style={{ fontSize: 12 }}>
      No test-wise commission set. Add tests from search above to override Pathology/Radiology for those tests.
    </div>
  ) : (
    <div className="table-responsive">
      <table className="table table-sm table-bordered align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: 50 }}>#</th>
            <th>Test Name</th>
            <th style={{ width: 160 }}>Type</th>
            <th style={{ width: 160 }}>Commission</th>
            <th style={{ width: 80 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {testCommissions.map((row, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{row.test_name}</td>
              <td>
                <select
                  className="form-control form-control-sm"
                  value={row.commission_type}
                  onChange={(e) => handleTestCommissionChange(idx, 'commission_type', e.target.value)}
                >
                  <option value="fix">Fix</option>
                  <option value="percentage">Percentage</option>
                </select>
              </td>
              <td>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={row.commission}
                  onChange={(e) => handleTestCommissionChange(idx, 'commission', e.target.value)}
                  placeholder="Amount"
                />
              </td>
              <td>
                <button type="button" className="btn btn-sm btn-outline-danger"
                  onClick={() => handleDeleteTestCommission(idx)}>
                  <i className="ri-delete-bin-5-fill"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>

{/* --- PATHOLOGY --- */}
<div className="col-md-3">
  <label className="form-label">Pathology Commission Type</label>
  <select className="form-control" name="lab_commission_pathology_type"
    onChange={handleChange} value={formData.lab_commission_pathology_type || ""}>
    <option value="">--</option>
    <option value="fix">Fix</option>
    <option value="percentage">Percentage</option>
  </select>
</div>
<div className="col-md-3">
  <label className="form-label">Pathology Commission</label>
  <input className="form-control" type="number" name="lab_commission_pathology"
    value={formData.lab_commission_pathology ?? ""} onChange={handleChange} placeholder="Enter Amount" />
</div>

{/* --- RADIOLOGY --- */}
<div className="col-md-3">
  <label className="form-label">Radiology Commission Type</label>
  <select className="form-control" name="lab_commission_radiology_type"
    onChange={handleChange} value={formData.lab_commission_radiology_type || ""}>
    <option value="">--</option>
    <option value="fix">Fix</option>
    <option value="percentage">Percentage</option>
  </select>
</div>
<div className="col-md-3">
  <label className="form-label">Radiology Commission</label>
  <input className="form-control" type="number" name="lab_commission_radiology"
    value={formData.lab_commission_radiology ?? ""} onChange={handleChange} placeholder="Enter Amount" />
</div>

{/* ============ HOSPITAL ============ */}
<div className="col-md-12">
  <h4 style={{ color: '#003366', borderBottom: '2px solid #003366', paddingBottom: 6, marginTop: 12 }}>
    Hospital Commission
  </h4>
</div>
<div className="col-md-3">
  <label className="form-label">Hospital Commission Type</label>
  <select className="form-control" name="hospital_commission_type" onChange={handleChange} value={formData.hospital_commission_type}>
    <option value="">--</option>
    <option value="fix">Fix</option>
    <option value="percentage">Percentage</option>
  </select>
</div>
<div className="col-md-3">
  <label className="form-label">Hospital Commission</label>
  <input className="form-control" type="number" name="hospital_commission"
    value={formData.hospital_commission} onChange={handleChange} placeholder="Enter Amount" />
</div>

{/* ============ PHARMACY ============ */}
<div className="col-md-12">
  <h4 style={{ color: '#003366', borderBottom: '2px solid #003366', paddingBottom: 6, marginTop: 12 }}>
    Pharmacy Commission
  </h4>
</div>
<div className="col-md-3">
  <label className="form-label">Pharmacy Commission Type</label>
  <select className="form-control" name="pharmacy_commission_type" onChange={handleChange} value={formData.pharmacy_commission_type}>
    <option value="">--</option>
    <option value="fix">Fix</option>
    <option value="percentage">Percentage</option>
  </select>
</div>
<div className="col-md-3">
  <label className="form-label">Pharmacy Commission</label>
  <input className="form-control" type="number" name="pharmacy_commission"
    value={formData.pharmacy_commission} onChange={handleChange} placeholder="Enter Amount" />
</div>
                

                
               
              </div>
            </div>

            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" id="closeBt45" className="btn btn-light" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="submit" className="btn btn-success" id="edit-btn">
                  {isEditing ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddDoctor;